import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api, formatApiError } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function DocumentTypesPage() {
  const [types, setTypes] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", code: "", description: "" });
  const [err, setErr] = useState("");

  const load = async () => setTypes((await api.get("/document-types")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/document-types", form);
      setOpen(false);
      setForm({ name: "", code: "", description: "" });
      load();
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail));
    }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/document-types/${id}`);
    load();
  };

  return (
    <AppShell
      title="Document Types"
      actions={
        <button data-testid="new-type-button" className="ds-btn-primary flex items-center gap-2" onClick={() => setOpen(true)}>
          <Plus size={14} /> New type
        </button>
      }
    >
      <div className="ds-card overflow-x-auto">
        <table className="ds-table" data-testid="types-table">
          <thead>
            <tr><th>Name</th><th>Code</th><th>Description</th><th /></tr>
          </thead>
          <tbody>
            {types.map((t) => (
              <tr key={t.id}>
                <td className="font-semibold">{t.name}</td>
                <td className="font-mono text-[12px]">{t.code}</td>
                <td className="text-[12px] text-[#4A4A52]">{t.description}</td>
                <td className="text-right">
                  <button className="ds-btn-ghost" onClick={() => remove(t.id)} data-testid={`delete-type-${t.id}`}>
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setOpen(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="ds-card p-6 w-full max-w-md" data-testid="new-type-form">
            <h3 className="font-display text-lg font-bold mb-4">Create document type</h3>
            <div className="space-y-3">
              <div><label className="ds-label">Name</label><input className="ds-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="new-type-name" /></div>
              <div><label className="ds-label">Code (lowercase, unique)</label><input className="ds-input" required pattern="[a-z0-9_-]+" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} data-testid="new-type-code" /></div>
              <div><label className="ds-label">Description</label><input className="ds-input" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
              {err && <div className="text-[12px] text-[#B42318]">{err}</div>}
            </div>
            <div className="mt-5 flex justify-end gap-2">
              <button type="button" className="ds-btn-secondary" onClick={() => setOpen(false)}>Cancel</button>
              <button type="submit" className="ds-btn-primary" data-testid="new-type-submit">Create</button>
            </div>
          </form>
        </div>
      )}
    </AppShell>
  );
}
